/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_SummaryInputs */

const en_read_along_ai_summary = /** @type {(inputs: Read_Along_Ai_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary`)
};

const es_read_along_ai_summary = /** @type {(inputs: Read_Along_Ai_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen`)
};

/**
* | output |
* | --- |
* | "Summary" |
*
* @param {Read_Along_Ai_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_summary = /** @type {((inputs?: Read_Along_Ai_SummaryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_SummaryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_summary(inputs)
	return en_read_along_ai_summary(inputs)
});